import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ShoppingBag, Search, Menu, X, User } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { api } from "@/lib/api";

const LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_0dbeb9ed-131c-4cd1-83ca-d7c4e02f284b/artifacts/rg17olpw_WhatsApp%20Image%202026-10-01%20at%2011.40.01.jpeg";

export default function Header() {
  const { count, setOpen } = useCart();
  const [cats, setCats] = useState([]);
  const [mobile, setMobile] = useState(false);
  const [q, setQ] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data || []));
  }, []);

  useEffect(() => {
    setMobile(false);
    setShowSearch(false);
  }, [loc.pathname]);

  const submitSearch = (e) => {
    e.preventDefault();
    if (q.trim()) nav(`/busca?q=${encodeURIComponent(q.trim())}`);
  };

  const topCats = cats.slice(0, 6);

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 glass">
      <div className="h-10 bg-black text-[11px] text-zinc-400 flex items-center justify-center tracking-[0.25em] uppercase border-b border-white/5">
        Frete grátis em compras acima de R$ 299 — Parcele em até 6x no cartão
      </div>
      <div className="mx-auto max-w-7xl px-5 lg:px-8 h-20 flex items-center gap-8">
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setMobile((v) => !v)}
          className="lg:hidden text-white"
          aria-label="Abrir menu"
        >
          {mobile ? <X size={22} /> : <Menu size={22} />}
        </button>
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3">
          <img src={LOGO} alt="ActiveMode" className="h-11 w-11 object-contain rounded-sm" />
          <div className="leading-none hidden sm:block">
            <div className="font-display text-lg tracking-tight text-white">ACTIVEMODE</div>
            <div className="overline-label mt-1">Vestuário &amp; Acessórios</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7 ml-6">
          <Link to="/" className="text-sm text-zinc-200 hover:text-white hover-underline">Início</Link>
          {topCats.map((c) => (
            <Link
              key={c.id}
              to={`/categoria/${c.slug}`}
              data-testid={`nav-cat-${c.slug}`}
              className="text-sm text-zinc-300 hover:text-white hover-underline"
            >
              {c.name}
            </Link>
          ))}
        </nav>

        <div className="flex-1" />

        <div className="flex items-center gap-5 text-white">
          <button
            data-testid="header-search-btn"
            onClick={() => setShowSearch((v) => !v)}
            aria-label="Buscar"
            className="hover:text-zinc-300 transition-colors"
          >
            <Search size={20} />
          </button>
          <Link to="/admin/login" aria-label="Admin" className="hidden sm:block hover:text-zinc-300 transition-colors" data-testid="header-admin-link">
            <User size={20} />
          </Link>
          <button
            data-testid="header-cart-btn"
            onClick={() => setOpen(true)}
            aria-label="Carrinho"
            className="relative hover:text-zinc-300 transition-colors"
          >
            <ShoppingBag size={20} />
            {count > 0 && (
              <span className="absolute -top-2 -right-2 bg-white text-black text-[10px] font-semibold rounded-full h-4 min-w-4 px-1 flex items-center justify-center" data-testid="cart-count">
                {count}
              </span>
            )}
          </button>
        </div>
      </div>

      {showSearch && (
        <form onSubmit={submitSearch} className="border-t border-white/10 bg-black px-5 lg:px-8 py-4">
          <input
            autoFocus
            data-testid="header-search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="O que você procura hoje?"
            className="w-full bg-transparent border-b border-white/20 focus:border-white outline-none text-white placeholder:text-zinc-500 py-2 text-lg font-display tracking-tight"
          />
        </form>
      )}

      {mobile && (
        <div className="lg:hidden border-t border-white/10 bg-black">
          <nav className="px-5 py-5 flex flex-col gap-4">
            <Link to="/" className="text-base text-zinc-200">Início</Link>
            {cats.map((c) => (
              <Link
                key={c.id}
                to={`/categoria/${c.slug}`}
                className="text-base text-zinc-300"
                data-testid={`mobile-nav-cat-${c.slug}`}
              >
                {c.name}
              </Link>
            ))}
            <Link to="/admin/login" className="text-base text-zinc-400 mt-3">Admin</Link>
          </nav>
        </div>
      )}
    </header>
  );
}
